function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgChatIconFilled = function SvgChatIconFilled(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    fillRule: "evenodd",
    d: "M3.778 3C2.796 3 2 3.796 2 4.778v10.819c0 1.584 1.915 2.377 3.035 1.257l1.41-1.41h9.777c.982 0 1.778-.796 1.778-1.777v-8.89C18 3.797 17.204 3 16.222 3zm2.586 5.333h7.272c.447 0 .808-.398.808-.889 0-.49-.361-.888-.808-.888H6.364c-.447 0-.808.398-.808.888 0 .491.361.89.808.89M10 11.89H6.444a.889.889 0 0 1 0-1.778H10a.889.889 0 0 1 0 1.778",
    clipRule: "evenodd"
  }));
};
export default SvgChatIconFilled;